module.exports = __webpack_public_path__ + "img/03.2dce5ac6.png";